/**
 * for vendor customize
 * @module vendorCustom/customizeBeforeInitScript
 */
define('vendorCustom/customizeBeforeInitScript',[],function () {
    // realgrid license, etc.

    var lic_dev = 'upVcPE+wPOksRHztag2HLt+UVTCvO3is+83EYTz6U/vf2HKI9Q7iAXO95zcSv4U6lQuJltLz/bDEuU/2Wr6IluAdT/x/EG1cN5XuycxN/o/hIb/1LofVeF+OnvmYzcyGLeQ2ZkeTzANclhusp71WS7TyYJbIZWIp3BWasMyUxCPsHQ+qAW550rvqkYd+6H3wDIyw62+ynUJIvdmTUtXx6eOz4tWYmDGNJNZENFVQgg0OqCi/WbXspL/213MsP9RQTGByKkhdpzP7pkZXEPFHtA==';
    var lic_prd = 'upVcPE+wPOksRHztag2HLtau1G7NGLZh+p2VI6Q9GDP/2ZvNHJTdEAxYh/bMEcGXGRMR/FjgGCm6vb452g1HHmP9PCLMW0/v7vKYcI/5zX3Jp8er6IB/H6HHcAoHa4Z9a+tCZqOvbIGAMIa465cZ7jLbyjXcWrOEbynpOoWi6Li5c7Kc+waJS0J7xUHPQ0TrnBU7FN+YJgoO5+/xJSE3LrhRLSG0r1Mtkn/JIEkiRbk=';
    var realGridJsLic = {
        "localhost": lic_dev,
        'local-hoin' : lic_dev,
        '192.168.0.39' : lic_dev,
        "sm-sap-unipost-alb-dev-733644493.ap-northeast-2.elb.amazonaws.com": lic_dev,
        "17.3.4.152": lic_dev,
        "local-sment": lic_dev,
        "eas-dev.smtown.com": lic_dev,
        "17.2.101.32": lic_prd,
        "17.2.102.19": lic_prd,
        "eas.smtown.com": lic_prd,
        "sm-sap-unipost-eaccounting-alb-243598473.ap-northeast-2.elb.amazonaws.com": lic_prd
    }

    function xmlReadCallback() {
        window.realGridJsLic = realGridJsLic[location.hostname];
        window.isLegalLicense = {
            "eas.smtown.com": true,
            "17.2.101.32": true,
            "17.2.102.19": true,
            "sm-sap-unipost-eaccounting-alb-243598473.ap-northeast-2.elb.amazonaws.com": true
        }[location.hostname];

        $customize.specPathes = $customize.specPathes.concat([
            'test/jasmine/viewSpec',
            'test/jasmine/efiSpec',
            'test/jasmine/ewfSpec'
        ]);
    }

    $.ajax({
        url: "/license/realgrid/read",
        async: false,
        dataType: 'json',
        method: "POST",
        data: {},
        success: function (result) {
            result.data.map(function (lic) {
                realGridJsLic[lic.host] = lic.key;
            });
            xmlReadCallback();
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);
            xmlReadCallback();
        }
    });
});
